export default {
  data: () => ({
    translations: {
      title_points: {
        el: 'Επιστροφή Πόντων',
        en: 'Points Return',
        it: 'Ritorno di punti',
      },
      title_cashback: {
        el: 'Επιστροφή Cashback',
        en: 'Cashback Return',
        it: 'Ritorno di Cashback',
      },
      info_points: {
        el: 'Θέλετε οι πόντοι να επιστρέφονται στον χρήστη μετά τη χρήση του κουπονιού;',
        en: 'Do you want points to be returned to the user after using the coupon?',
        it: "Vuoi che i punti vengano restituiti all'utente dopo aver utilizzato il buono?",
      },
      info_cashback: {
        el: 'Θέλετε το cashback να επιστρέφεται στον χρήστη μετά τη χρήση του κουπονιού;',
        en: 'Do you want cashback to be returned to the user after using the coupon?',
        it: "Vuoi che il cashback venga restituito all'utente dopo aver utilizzato il buono?",
      },
      yes: {
        el: 'Ναι',
        en: 'Yes',
        it: 'Sì',
      },
      no: {
        el: 'Όχι',
        en: 'No',
        it: 'No',
      },
    },
  }),
};
